import axios from "axios";
import { Baseurl } from "../baseurl";
import { toast } from "react-toastify";

export const fetchYards = async () => {
  try {
    const response = await axios.get(`${Baseurl}/api/yards/getAllYardForAdmin`);
    console.log(response.data?.yards, "response.data?.yards");
    return response.data;
    // setYards(response.data?.yards);
    // setError(null);
  } catch (err) {
    // setError("Failed to fetch yards. Please try again.");
    console.error("Error fetching yards:", err);
    toast.error("Error fetching yards");
  } finally {
    // setLoading(false);
  }
};
